import { isNil } from "lodash";
import type { NestedObject } from "./model/nested-object.model";

/**
 * Get all keys from a nested object.
 * @param obj The object to get keys from.
 * @returns An array of all keys in the object.
 */
export function allKeys(obj: NestedObject): string[] {
  if (isNil(obj)) return [];

  const keys = Object.keys(obj);
  return [...keys, ...keys.flatMap((key) => (obj[key] && typeof obj[key] === "object" ? allKeys(obj[key]) : []))];
}
